import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { afterItems, beforeItems } from "../../data/content";
export function BeforeAfter() {
  return <section className="bg-cream px-4 py-16 sm:py-24" data-id="element-112" data-mp="26luonyxbie5l">
      <div className="mx-auto max-w-5xl" data-id="element-113" data-mp="26k9y0ke4jfd0">
        <h2 className="text-balance text-center font-serif text-3xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-114" data-mp="22lasoyohdgl1">
          What you should be able to do <em className="text-gold" data-id="element-115" data-mp="2za8omk7yvkjs">after using the system</em>
        </h2>

        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-116" data-mp="2ud8kwfylatvu">
          <div className="rounded-3xl border border-alert/20 bg-white p-6 sm:p-8" data-id="element-117" data-mp="2qa3iedeies77">
            <div className="flex items-center gap-3" data-id="element-118" data-mp="2qc6ftihzrnly">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-alert/10 text-alert" data-id="element-119" data-mp="2lah749i8rm11">
                <XIcon className="h-5 w-5" strokeWidth={3} aria-hidden="true" data-id="element-120" data-mp="1ewrk0i1ir1sf" />
              </span>
              <h3 className="font-serif text-2xl font-bold text-alert" data-id="element-121" data-mp="19uiu5ujy0fuj">Before</h3>
            </div>
            <ul className="mt-5 space-y-3.5" data-id="element-122" data-mp="175vy11zzq5on">
              {beforeItems.map(b => <li key={b} className="flex items-start gap-3 text-[16px] leading-relaxed text-ink/75" data-id="element-123" data-mp="1c35psoauqtfn">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-alert" strokeWidth={3} aria-hidden="true" data-id="element-124" data-mp="y462pl2zmmll" />
                  {b}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-navy p-6 text-white ring-2 ring-cta sm:p-8" data-id="element-125" data-mp="odbi0l5e3v29">
            <div className="flex items-center gap-3" data-id="element-126" data-mp="t6czn0wze8pj">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-cta text-white" data-id="element-127" data-mp="fe6ltlhawdt9">
                <CheckIcon className="h-5 w-5" strokeWidth={3} aria-hidden="true" data-id="element-128" data-mp="jfi9vmkj0qzc" />
              </span>
              <div data-id="element-129" data-mp="5fgzngidg777">
                <h3 className="font-serif text-2xl font-bold text-white" data-id="element-130" data-mp="5h1tt50rxo4j">After</h3>
                <p className="text-xs font-bold uppercase tracking-wider text-goldlight" data-id="element-131" data-mp="afmuf5jxu9ti">With the Mastopexy Blueprint™</p>
              </div>
            </div>
            <ul className="mt-5 space-y-3.5" data-id="element-132" data-mp="2c6dmvtg2d8vb">
              {afterItems.map(a => <li key={a} className="flex items-start gap-3 text-[16px] leading-relaxed text-white/90" data-id="element-133" data-mp="27c9f57yz4wt6">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-[#4ADE80]" strokeWidth={3} aria-hidden="true" data-id="element-134" data-mp="239uvilnhdt0u" />
                  {a}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-2xl space-y-2 text-center" data-id="element-135" data-mp="2r1jsifb8z5o4">
          <p className="text-[17px] text-ink/75" data-id="element-136" data-mp="2r2bb8pjqx8wz">The goal isn't to give you more information.</p>
          <p className="font-serif text-2xl font-bold leading-snug text-navy" data-id="element-137" data-mp="2m0m1rec693b0">
            It's to help you get more value from the information you <em className="text-gold" data-id="element-138" data-mp="1an0drwi1t7r2">already have.</em>
          </p>
        </div>

        <div className="mt-10" data-id="element-139" data-mp="1akxf6o2ty6aq">
          <CTAButton label="I want to review mastopexy with a system" data-id="element-140" data-mp="15nxiv4vs8hwt" />
        </div>
      </div>
    </section>;
}